import React, { Component } from "react";
import styled from "styled-components";
import * as BSDropdown from "react-bootstrap/Dropdown";

const CustomToggleContainer = styled.div`
  border: solid 2px lightgray;
  width: 95%;
  margin: auto;
  text-align: center;
  padding: 15px;
  border-radius: 5px;
`;

const CustomMenuContainer = styled.div`
  border: solid 2px lightgray;
  width: 100%;
  border-radius: 5px;
  text-align: center;
  padding: 0px;
`;

const CustomMenuItem = styled(BSDropdown.Item)`
  padding: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${props => props.selected && "lightgray"};
`;

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <CustomToggleContainer ref={ref} onClick={e => onClick(e)}>
    {children}
    &#x25bc;
  </CustomToggleContainer>
));

const CustomMenu = React.forwardRef(
  ({ children, style, className, "aria-labelledby": labeledBy }, ref) => {
    return (
      <CustomMenuContainer
        ref={ref}
        style={style}
        className={className}
        aria-labelledby={labeledBy}
      >
        <ul className="list-unstyled">{children}</ul>
      </CustomMenuContainer>
    );
  }
);

class Dropdown extends Component {
  state = {
    showDrop: false
  }

  onDropdownItemClick = idx => {
    this.props.onClick(idx)
    this.setState({
      showDrop: true
    })
  }

  render() {
    const { titleList, selectedIdx } = this.props;
    const { showDrop } = this.state;
    return (
      <BSDropdown style={{ display: "flex" }}>
        <BSDropdown.Toggle
          as={CustomToggle}
          id="dropdown-toggle"
          show={false}
          onSelect={() => this.setState({ showDrop: !showDrop})}
        >
          Click to edit project
        </BSDropdown.Toggle>

        <BSDropdown.Menu as={CustomMenu}>
          {titleList.map((item, key) => (
            <CustomMenuItem
              selected={key === selectedIdx}
              as="button"
              key={key}
              onClick={() => this.onDropdownItemClick(key)}
              data-toggle="dropdown-toggle"
            >
              {item}
            </CustomMenuItem>
          ))}
        </BSDropdown.Menu>
      </BSDropdown>
    );
  }
}

export default Dropdown;
